import React from "react";
import { MantineProvider, createTheme } from "@mantine/core";
import { useThemeMode } from './ThemeContext';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  const { mode, setMode, toggleMode } = useThemeMode();

  const theme = createTheme({
    breakpoints: {
      xs: '30em',
      sm: '48em',
      md: '64em',
      lg: '74em',
      xl: '90em',
    },
    colors: {
      blue: [
        '#e6f7ff',
        '#b3e6ff',
        '#80d5ff',
        '#4dc4ff',
        '#1ab3ff',
        '#0099e6',
        '#0078b4',
        '#005580',
        '#00334d',
        '#00111a'
      ],
      green: [
        '#e8f5e9',
        '#c8e6c9',
        '#a5d6a7',
        '#81c784',
        '#66bb6a',
        '#4caf50',
        '#43a047',
        '#388e3c',
        '#2e7d32',
        '#1b5e20'
      ],
    },
    primaryColor: "blue",
  });

  React.useEffect(() => {
    const id = 'custom-theme-style';
    let styleEl = document.getElementById(id) as HTMLLinkElement | null;
    if (styleEl) {
      styleEl.parentNode?.removeChild(styleEl);
    }
    styleEl = document.createElement('link');
    styleEl.id = id;
    styleEl.rel = 'stylesheet';
    styleEl.href = mode === 'dark' ? './dark.css' : './light.css';
    document.head.appendChild(styleEl);
    return () => {
      if (styleEl && styleEl.parentNode) {
        styleEl.parentNode.removeChild(styleEl);
      }
    };
  }, [mode]);

  return (
    <MantineProvider theme={theme} forceColorScheme={mode}>
      {children}
    </MantineProvider>
  );
}
